<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Categorias</h4>
          <router-link to="/app/products/category">
            <l-button wide type="primary" round v-if="permission('create_category')">
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Criar
            </l-button>
          </router-link>
          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <div class="x-page-links">
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
        </div>

        <div class="table-responsive table-full-width">
          <el-table
            class="table-striped"
            :data="tableData().filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()) ||
            data.description.toLowerCase().includes(search.toLowerCase()))"
          >
            <el-table-column label="Nome" property="name" sortable />
            <el-table-column label="Posição" property="position"  sortable />
            <el-table-column label="Filial" property="company_name" v-if="showMatriz" sortable />
            <el-table-column label="Descrição" property="description"  />
            <el-table-column label="Ações" width="90">
              <div class="td-actions" slot-scope="props">
                <el-tooltip class="item" effect="dark" content="Editar" placement="top-start">
                    <a
                    v-if="permission('edit_category')"
                    class="btn btn-warning btn-link btn-xs"
                    @click="handleEdit(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Deletar" placement="top-start">
                  <a
                  v-if="permission('delete_category')"
                  class="btn btn-danger btn-link btn-xs"
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-close"></i>
                </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Tooltip } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      search: '',
      ciaID: '',
      categories: []
    };
  },
  computed: {
    showItem() {
      const smartmach = localStorage.getItem("smartmach");
      if (smartmach === "true") {
        return true;
      } else {
        return false;
      }
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    const ciaID = localStorage.getItem('smartmachCiaID')
    this.ciaID = ciaID
    if (ciaID) {
      this.getData(ciaID)
    } else {
      this.getData()
    }
    this.getListCompany()
    // setInterval(function() {
    //   window.location.reload();
    // }, this.$store.state.general.timer);
  },
  methods: {
    tableData() {
      const categories = this.categories
      return categories;
    },
    getData (id) {
      if (id) {
        id = id
      } else {
        id = ''
      }
      this.$store.dispatch("categories/listSort",{sort: '?company=' + id}).then(resp =>{
        this.categories = resp
      }).catch(err => console.log(err));
    },
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/products/category/${row.id}`);
    },
    permission(permissao) {
      var x = this.$store.state.general.permission.permissoes_do_usuario.filter(
        el => {
          if (el == permissao) {
            return true;
          }
        }
      );
      if (x.length > 0) {
        return true;
      }
      if (localStorage.getItem("parent_company")) {
        return true
      } 
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    handleDelete(i, row) {
      console.log(row);
      const itemName = "Categoria";
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("categories/delete", { id: row.id }).then(()=> {
            swal.fire({
              title: "Pronto!",
              text: `${itemName} excluído(a).`,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
              if (this.ciaID) {
                this.getData(this.ciaID)
              } else {
                this.getData()
              }
          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
.x-page-links {
  margin-top: 15px;
  text-align: left;
}
</style>
